//-----------------------------------
// featured-collection.js
// => theme/sections/featured-collection.liquid
//-----------------------------------

import $ from 'jquery';

/* DOM References
=====================================*/

/* Featured Collection Module
=====================================*/
export let featuredCollection = {
    init() {
        featuredCollection.swatches();
    },
    swatches() {
        $('.js-SwatchItem').on('click', function() {
        console.log("I was clicked...");
        let $this = $(this);
        let the_handle = $(this).attr('data-handle');
        let root_url = window.Shopify.routes.root;
        let the_new_url = root_url + 'products/' + the_handle;
        // let the_new_img =  $(this).attr('data-img-src');
        let the_img_tag = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-image');
        let the_img_link = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-imagelink');
        let the_title_link = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-title');
        let mobile_quick_btn = $(this)
            .closest('.ProductGridItemNew')
            .find('.js-ProductGridItemNew-quick');
        let the_select = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-select');
        let the_select_visible = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-select:visible');
        let the_desk_select = $(this)
            .closest('.ProductGridItemNew')
            .find('.ProductGridItemNew-selectDesk');
        let the_desk_quick = $(this)
            .closest('.ProductGridItemNew')
            .find('.js-ProductGridQuickView');
        let the_item = $(this).closest('.ProductGridItemNew');
        let is_bundle = false;
        let is_kit = false;
        let current_index_mobile, current_index_desktop;
        
        // the_img_tag.attr('srcset', the_new_img);
        if ( the_select.attr('data-bundle') === 'true' ){
            is_bundle = true;
            // CollectionVueSelectWrap
            current_index_mobile = $(this).closest('.ProductGridItemNew').find('.CollectionVueSelectWrap--mobile > div:first-child').text();
            current_index_mobile = parseInt(current_index_mobile);
            current_index_desktop = $(this).closest('.ProductGridItemNew').find('.CollectionVueSelectWrap-desk > div:first-child').text();
            the_vues[current_index_mobile].resetData(the_handle);
            if( the_vues[current_index_desktop] !== undefined ){
            the_vues[current_index_desktop].resetData(the_handle);
            }
        }
    
        if ( the_item.attr('data-is-kit') === 'true' ){
            is_kit = true;
            // console.log('the endpoint: '+ the_endpoint)
            let the_url = window.Shopify.routes.root + 'products/'+the_handle+'?view=kitjson';
            axios.get(the_url)
            .then(function (response) {
                console.log(response);
                let data = response.data
                console.log('swatched: ' + data.title);
                the_img_tag.attr('srcset', data.images[0]);
    
                the_img_tag.attr('data-src', data.images[0]);
                the_img_tag.attr('alt', data.title);
                the_img_tag.attr('data-srcset', data.images[0]);
    
                // Update the links
                the_img_link.attr('href', the_new_url);
                the_title_link.attr('href', the_new_url);
    
                // Update the handles
                console.log('data handle: ' + data.handle);
                mobile_quick_btn.attr('data-handle', data.handle);
                the_desk_quick.attr('data-handle', data.handle);
                the_item.attr('data-handle', data.handle);
                // if it's not a bundle
            if(!is_bundle){
                // remove the options from the current select menu, change them to be the
                console.log('empty the select menu ');
                the_select.empty();
                the_desk_select.empty();
                the_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">Choose Your Size</option>'
                );
                the_desk_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">ADD NOW</option>'
                );
                // setTimeout( function(){
                console.log('getting variants');
                // Get all the variants
                $.each(data.variants, function(key, value) {
                let variant = value;
                let theVariantID = variant.id;
                let theVariantTitle = variant.title;
                let is_default = false;
                let theVariantSku = variant.sku;
                console.log(theVariantSku);
                let theVariantPrice = variant.price / 100;
                theVariantPrice = theVariantPrice.toFixed(2);
    
                let inStock = variant.available;
                // let continueSelling = variant.inventory_policy;
                let theVariantQuantity = parseInt(variant.inventory_quantity, 10);
                if (theVariantTitle.includes('/')) {
                    theVariantTitle = theVariantTitle.substr(0, theVariantTitle.indexOf(' /'));
                } else {
                    console.log('variant title: ' + theVariantTitle);
                    is_default = true;
                }
                // if the variant is in stock,
                if (inStock) {
                    if (theVariantQuantity <= 0 && variant.inventory_management != null) {
                    the_select.append(
                        '<option role="option" class="ProductGridItemNew-option"  data-title="' +
                        theVariantTitle +
                        '" data-preorder="preorder" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '" data-price="' +
                        theVariantPrice +
                        '">' +
                        theVariantTitle +
                        ' (PREORDER)</option>'
                    );
                    } else {
                    // If there's one title, select this, and append it. Call it "one size" or something instead fo the variant ID
                    if (is_default) {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">One Size</option>'
                        );
                    } else {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">' +
                            theVariantTitle +
                            '</option>'
                        );
                    }
                    }
                } else {
                    the_select.append(
                    '<option disabled data-title="' +
                        theVariantTitle +
                        '" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '">' +
                        theVariantTitle +
                        ' - SOLD OUT</option>'
                    );
                }
                });
    
            }
            if (the_select_visible.length == 0 && $(window).width() < 1024) {
                TweenMax.to(the_select, 0.1, { autoAlpha: 1, display: 'block', ease: Power2.ease });
                TweenMax.to(mobile_quick_btn, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
            }
            // Select the right swatch
            console.log('add this class');
            $this.addClass('swatchItem--is-active');
            $this.siblings('.swatchItem--is-active').removeClass('swatchItem--is-active');
    
            the_item.find('.ProductGridItemNew-kitItems').text(data.the_kit_items)
            
                
            })
            .catch(function (error) {
                console.log(error);
                
            });
        }else{
            let the_url = window.Shopify.routes.root + 'products/' + the_handle + '.js'
            let promise = $.getJSON(the_url);
            promise.done(function(data) {
            console.log('swatched: ' + data.title);
            the_img_tag.attr('srcset', data.images[0]);
    
            the_img_tag.attr('data-src', data.images[0]);
            the_img_tag.attr('alt', data.title);
            the_img_tag.attr('data-srcset', data.images[0]);
    
            // Update the links
            the_img_link.attr('href', the_new_url);
            the_title_link.attr('href', the_new_url);
    
            // Update the handles
            console.log('data handle: ' + data.handle);
            mobile_quick_btn.attr('data-handle', data.handle);
            the_desk_quick.attr('data-handle', data.handle);
            the_item.attr('data-handle', data.handle);
            
            // if it's not a bundle
            if(!is_bundle){
                // remove the options from the current select menu, change them to be the
                console.log('empty the select menu ');
                the_select.empty();
                the_desk_select.empty();
                the_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">Choose Your Size</option>'
                );
                the_desk_select.append(
                '<option class="ProductGridItemNew-option ProductGridItemNew-option-label" value="label" selected="" role="label" id="option-label">ADD NOW</option>'
                );
                // setTimeout( function(){
                console.log('getting variants');
                // Get all the variants
                $.each(data.variants, function(key, value) {
                let variant = value;
                let theVariantID = variant.id;
                let theVariantTitle = variant.title;
                let is_default = false;
                let theVariantSku = variant.sku;
                console.log(theVariantSku);
                let theVariantPrice = variant.price / 100;
                theVariantPrice = theVariantPrice.toFixed(2);
    
                let inStock = variant.available;
                // let continueSelling = variant.inventory_policy;
                let theVariantQuantity = parseInt(variant.inventory_quantity, 10);
                if (theVariantTitle.includes('/')) {
                    theVariantTitle = theVariantTitle.substr(0, theVariantTitle.indexOf(' /'));
                } else {
                    console.log('variant title: ' + theVariantTitle);
                    is_default = true;
                }
                // if the variant is in stock,
                if (inStock) {
                    if (theVariantQuantity <= 0 && variant.inventory_management != null) {
                    the_select.append(
                        '<option role="option" class="ProductGridItemNew-option"  data-title="' +
                        theVariantTitle +
                        '" data-preorder="preorder" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '" data-price="' +
                        theVariantPrice +
                        '">' +
                        theVariantTitle +
                        ' (PREORDER)</option>'
                    );
                    } else {
                    // If there's one title, select this, and append it. Call it "one size" or something instead fo the variant ID
                    if (is_default) {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">One Size</option>'
                        );
                    } else {
                        the_select.append(
                        '<option role="option" data-title="' +
                            theVariantTitle +
                            '"  data-quantity="' +
                            theVariantQuantity +
                            '" value="' +
                            theVariantID +
                            '" data-sku="' +
                            theVariantSku +
                            '" data-price="' +
                            theVariantPrice +
                            '">' +
                            theVariantTitle +
                            '</option>'
                        );
                    }
                    }
                } else {
                    the_select.append(
                    '<option disabled data-title="' +
                        theVariantTitle +
                        '" value="' +
                        theVariantID +
                        '" data-sku="' +
                        theVariantSku +
                        '">' +
                        theVariantTitle +
                        ' - SOLD OUT</option>'
                    );
                }
                });
    
            }
            
                
    
            // }, 75 );
            if (the_select_visible.length == 0 && $(window).width() < 1024) {
                TweenMax.to(the_select, 0.1, { autoAlpha: 1, display: 'block', ease: Power2.ease });
                TweenMax.to(mobile_quick_btn, 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
            }
            // Select the right swatch
            console.log('add this class');
            $this.addClass('swatchItem--is-active');
            $this.siblings('.swatchItem--is-active').removeClass('swatchItem--is-active');
            });
    
            promise.fail(function(textStatus, error) {
            let err = textStatus + ', ' + error;
            console.log(textStatus + ' Request Failed: ' + err);
            });
        }
    
        });
    
        $('.swatchItemMore').click(function() {
        //  let hidden_swatches =  $(this).closest('.ProductGridItemNew-swatch').find('.swatchItem--hidden');
        $(this)
            .closest('.ProductGridItemNew-swatch')
            .addClass('wrap');
        TweenMax.to($(this).siblings(), 0.1, { autoAlpha: 1, display: 'flex', ease: Power2.ease });
        TweenMax.to($(this), 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
        //  TweenMax.to( $(this).siblings(), 0.1, { autoAlpha: 0, display:'none', ease: Power2.ease } );
        TweenMax.to($(this).siblings('.swatchItemLess'), 0.1, {
            autoAlpha: 1,
            display: 'flex',
            ease: Power2.ease
        });
        });
        $('.swatchItemLess').click(function() {
        // let hidden_swatches =  $(this).closest('.ProductGridItemNew-swatch').find('.swatchItem--hidden');
        TweenMax.to($(this), 0.1, { autoAlpha: 0, display: 'none', ease: Power2.ease });
        TweenMax.to($(this).siblings('.swatchItem--hidden'), 0.1, {
            autoAlpha: 0,
            display: 'none',
            ease: Power2.ease
        });
        TweenMax.to($(this).siblings('.swatchItemMore'), 0.1, {
            autoAlpha: 1,
            display: 'flex',
            ease: Power2.ease
        });
        });
    }
}